<template>
  <div
    :class="
      cn(
        'rt-card glass-frosted relative rounded-8xl w-335 h-67.5 gap-4 flex flex-col p-4',
        props.class,
      )
    "
  >
    <header class="w-full flex items-center gap-3 shrink-0">
      <div class="flex items-center gap-2 min-w-0">
        <Icon :icon="icon" class="size-5 text-black-white" />
        <h3 class="text-l-medium text-black-white truncate">{{ title }}</h3>
      </div>
      <!--
        紧贴 title 的额外控件（如手输数值框）。与 #header-action 互不干扰：
        左侧 group 用 min-w-0 + truncate 让 title 在空间不足时优雅截断，
        这里只承担「贴在 title 右侧」的角色，宽度由自身内容决定。
      -->
      <slot name="header-title-action" />
      <!-- 中间弹性占位，把 #header-action 推到右端 -->
      <div class="flex-1 min-w-0" />
      <!--
        1. 优先使用 #header-action 自定义右侧操作（如开关、按钮组）；
        2. 否则当外部传入 mode 时渲染左右模式选择器；
        3. 都没有则保持 header 留白。
      -->
      <slot name="header-action">
        <RtModeSelector
          v-if="mode !== undefined"
          :model-value="mode"
          :disabled="loading"
          @update:model-value="(v) => $emit('update:mode', v)"
        />
      </slot>
    </header>
    <div class="rt-card__body flex-1 flex items-center justify-start min-h-0">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { cn, Icon } from '@rapoo/element'
  import RtModeSelector from './RtModeSelector.vue'
  import type { RtSelectionMode } from '../types'
  import { HTMLAttributes } from 'vue'

  const props = defineProps<{
    /** header 左侧图标名称（@rapoo/element Icon） */
    icon: string
    /** header 标题文本 */
    title: string
    /** 左右/单侧模式选择器当前值；不传则不渲染选择器 */
    mode?: RtSelectionMode
    class?: HTMLAttributes['class']
    loading?: boolean
  }>()

  defineEmits<{
    'update:mode': [value: RtSelectionMode]
  }>()
</script>
